export default __webpack_public_path__ + "static/explain_small-1de4cc4df1596b2370d253b57915844c.png";